<script setup lang="ts">
import SanityBlockInlineImage from './SanityBlockInlineImage.vue'
import SanityBlockTable from './SanityBlockTable.vue'
import SanityBlockColorText from './SanityBlockColorText.vue'
import SanityBlockFaq from './SanityBlockFaq.vue'

const props = defineProps<{
  blocks: any
}>()

const serializers = {
  types: {
    image: SanityBlockInlineImage,
    table: SanityBlockTable,
    colorText: SanityBlockColorText,
    faq: SanityBlockFaq,
  },
}
</script>

<template>
  <SanityContent :blocks="blocks" :serializers="serializers" />
</template>
